/*
 * Exports
 */
export { default } from './components/CheckedOutReadingLinks.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/checked-out-reading-links/index.js